import { Component, input } from '@angular/core';
import { ToolbarModule } from 'primeng/toolbar';
import { LogoComponent } from "../logo/logo.component";
import { AppTitleComponent } from "../app-title/app-title.component";
import { UserInfoComponent } from "../user-info/user-info.component";
import { PreferencesComponent } from "../preferences/preferences.component";
import { HelpComponent } from "../help/help.component";
import { HeaderDowntimeComponent } from "../header-downtime/header-downtime.component";


@Component({
  selector: 'app-header',
  imports: [LogoComponent, AppTitleComponent, UserInfoComponent, PreferencesComponent, ToolbarModule, HelpComponent, HeaderDowntimeComponent],
  templateUrl: './header.component.html',
  styles: `
  :host {
    background-image: url('/header-background.jpg');
    background-size: cover;
  }
  `
})
export class HeaderComponent {

  authenticated = input()

  constructor() {}

}
